import { xMedian } from '../x';
import { matrixToArray } from './matrixToArray';
/**
 * Returns the median of the matrix.
 * @param matrix
 */
export function matrixMedian(matrix) {
    return xMedian(matrixToArray(matrix));
}
//# sourceMappingURL=matrixMedian.js.map